import { Routes } from '@angular/router';
import { PrimaryLayoutComponent } from './layouts/primary-layout/primary-layout.component';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: PrimaryLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(c => c.ProfileComponent)
      },
      {
        path: 'profile/:id',
        loadComponent: () => import('./pages/profile/profile.component').then(c => c.ProfileComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/user-list/user-list.component').then(c => c.UserListComponent),
      },
      {
        path: 'user/:id',
        loadComponent: () => import('./pages/user-profile/user-profile.component').then(c => c.UserProfileComponent),
      },
      {
        path: 'concept',
        loadComponent: () => import('./pages/concept-page/concept-page.component').then(c => c.ConceptPageComponent),
      },
      {
        path: 'concept/:conceptId',
        loadComponent: () => import('./pages/concept-page/concept-page.component').then(c => c.ConceptPageComponent),
      },
      {
        path: 'discussion',
        loadComponent: () => import('./pages/discussions-page/discussions-page.component').then(c => c.DiscussionsPageComponent),
      },
      {
        path: 'discussion/:discussionId',
        loadComponent: () => import('./pages/discussions-page/discussions-page.component').then(c => c.DiscussionsPageComponent),
      },
      {
        path: 'government',
        loadComponent: () => import('./pages/government-page/government-page.component').then(c => c.GovernmentPageComponent),
      },
      {
        path: 'news',
        loadComponent: () => import('./pages/news-page/news-page.component').then(c => c.NewsPageComponent),
      },
      {
        path: 'auth',
        loadComponent: () => import('./pages/auth/auth.component').then(c => c.AuthComponent),
      },
      {
        path: 'signin',
        loadComponent: () => import('./pages/auth/auth.component').then(c => c.AuthComponent),
      },
      {
        path: 'register',
        loadComponent: () => import('./pages/auth/auth.component').then(c => c.AuthComponent),
      },
      {
        path: 'forgotpass',
        loadComponent: () => import('./pages/auth/auth.component').then(c => c.AuthComponent),
      },
    ]

  },
  {
    path: '',
    component: EmptyLayoutComponent,
    children: [
      {
        path: 'test1',
        loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent)
      },
      {
        path: 'dev/design',
        loadComponent: () => import('./pages/dev-design/dev-design.component').then(c => c.DevDesignComponent)
      },
    ]

  },
  // {
  //   path: 'deferrable-views',
  //   loadComponent: () => import('./pages/deferrable-views/deferrable-views.component').then(c => c.DeferrableViewsComponent),
  // },
  // {
  //   path: 'ssg',
  //   loadComponent: () => import('./pages/ssg/ssg.component').then(c => c.SsgComponent)
  // },
  // {
  //   path: 'ssr',
  //   loadComponent: () => import('./pages/ssr/ssr.component').then(c => c.SsrComponent)
  // },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(c => c.NotFoundComponent)
  }
];
